import React, { useCallback, useState } from 'react'
import ScriptTag from '@v4/components/common/ScriptTag'

const withPreloadLibphonenumber = (Component, Fallback) => props => {
	const [loaded, setLoaded] = useState(false)
	const handleLoad = useCallback(() => {
		setLoaded(true)
	}, [])

	return loaded ? (
		<Component {...props} />
	) : (
		<>
			<Fallback {...props} />
			<ScriptTag
				onLoad={handleLoad}
				onError={handleLoad}
				src={`${import.meta.env.VITE_ASSET_URL}/lib/google-libphonenumber/libphonenumber.js`}
			/>
		</>
	)
}

export default withPreloadLibphonenumber
